(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["embrolab-gallery"] && !Shopify.designMode) return;
  try {
    function setupEmbrolabGallery(){
 const root=document.getElementById('ksa-root');
 const gallery=root?.querySelector('.kg');
 if(!gallery)return;
 if(gallery.kgAbort)gallery.kgAbort.abort();
 const abort=new AbortController();gallery.kgAbort=abort;const signal=abort.signal;
 const cards=Array.from(gallery.querySelectorAll('.kg-card'));
 const filters=Array.from(gallery.querySelectorAll('.kg-filter'));
 const filterGroup=gallery.querySelector('.kg-filters');
 const more=gallery.querySelector('.kg-more');
 const status=gallery.querySelector('.kg-results');
 const dialog=gallery.querySelector('.kg-dialog');
 const photo=dialog.querySelector('.kg-dialog-photo');
 const video=dialog.querySelector('.kg-dialog-video');
 const caption=dialog.querySelector('.kg-dialog-caption');
 const original=dialog.querySelector('.kg-dialog-original');
 const error=dialog.querySelector('.kg-error');
 const position=dialog.querySelector('.kg-position');
 const batchSize=8;
 let category='all',limit=batchSize,selected=0,trigger=null,oldOverflow=null,touchStart=null;
 const lang=()=>root.dir==='rtl'?'ar':'en';
 const matching=()=>cards.filter(card=>category==='all'||card.dataset.category===category);
 function updateText(){
  const items=matching(),count=Math.min(limit,items.length);
  status.textContent=status.dataset['template'+(lang()==='ar'?'Ar':'En')].replace('{shown}',String(count)).replace('{total}',String(items.length));
  cards.forEach(card=>{const link=card.querySelector('a'),image=link.querySelector('.kg-media > img');if(image)image.alt=link.dataset[lang()];});
  if(dialog.open){const link=items[selected]?.querySelector('a');if(link){caption.textContent=link.dataset[lang()];photo.alt=link.dataset[lang()];}}
 }
 function render(){
  const items=matching();let visible=0;
  cards.forEach(card=>{
   const match=category==='all'||card.dataset.category===category;
   card.hidden=!match||visible>=limit;
   if(!card.hidden){
    const deferred=card.querySelector('.kg-deferred-photo');
    if(deferred){deferred.replaceWith(deferred.content.cloneNode(true));card.querySelector('noscript')?.remove();}
   }
   if(match)visible++;
  });
  filters.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.filter===category)));
  more.hidden=limit>=items.length;updateText();
 }
 function closeGallery(){if(dialog.open)dialog.close();}
 function stopVideo(){if(video.hasAttribute('src')){video.pause();video.removeAttribute('src');video.removeAttribute('poster');video.load();}}
 function restore(){if(oldOverflow!==null){document.body.style.overflow=oldOverflow;oldOverflow=null;}stopVideo();photo.removeAttribute('src');photo.alt='';error.hidden=true;if(trigger?.isConnected)trigger.focus({preventScroll:true});}
 function showItem(index){
  const items=matching();if(!items.length)return;
  selected=(index+items.length)%items.length;
  const card=items[selected],link=card.querySelector('a'),isVideo=card.dataset.kind==='video';error.hidden=true;
  stopVideo();photo.removeAttribute('src');photo.hidden=isVideo;video.hidden=!isVideo;
  if(isVideo){video.poster=link.dataset.poster;video.src=link.href;}else{photo.src=link.href;photo.alt=link.dataset[lang()];}
  caption.textContent=link.dataset[lang()];original.href=link.dataset.original||link.href;position.textContent=(selected+1)+' / '+items.length;
  if(dialog.open&&isVideo)video.play().catch(()=>{});
 }
 filterGroup.hidden=false;status.hidden=false;
 filters.forEach(button=>button.addEventListener('click',()=>{
  if(category===button.dataset.filter)return;
  const apply=()=>{category=button.dataset.filter;limit=batchSize;render();};
  if(document.startViewTransition&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches)document.startViewTransition(apply);else apply();
 },{signal}));
 more.addEventListener('click',()=>{const firstNew=matching()[limit];limit+=batchSize;render();firstNew?.querySelector('a').focus({preventScroll:true});},{signal});
 const supportsDialog=typeof dialog.showModal==='function';
 cards.forEach(card=>{const link=card.querySelector('a');if(supportsDialog){link.setAttribute('aria-haspopup','dialog');link.addEventListener('click',event=>{
  if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button!==0)return;
  event.preventDefault();trigger=link;showItem(matching().indexOf(card));oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';dialog.showModal();dialog.querySelector('.kg-close').focus();if(!video.hidden)video.play().catch(()=>{});
 },{signal});}});
 dialog.querySelector('.kg-close').addEventListener('click',closeGallery,{signal});
 dialog.querySelector('.kg-prev').addEventListener('click',()=>showItem(selected-1),{signal});
 dialog.querySelector('.kg-next').addEventListener('click',()=>showItem(selected+1),{signal});
 dialog.addEventListener('close',restore,{signal});
 dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)closeGallery();},{signal});
 dialog.addEventListener('keydown',event=>{if(event.target===video)return;if(event.key==='ArrowRight'){event.preventDefault();showItem(selected+1);}else if(event.key==='ArrowLeft'){event.preventDefault();showItem(selected-1);}},{signal});
 photo.addEventListener('error',()=>{if(photo.hasAttribute('src'))error.hidden=false;},{signal});
 video.addEventListener('error',()=>{if(video.hasAttribute('src'))error.hidden=false;},{signal});
 document.addEventListener('visibilitychange',()=>{if(document.hidden&&video.hasAttribute('src'))video.pause();},{signal});
 photo.addEventListener('pointerdown',event=>{if(event.pointerType==='touch')touchStart={x:event.clientX,y:event.clientY};},{passive:true,signal});
 photo.addEventListener('pointerup',event=>{if(touchStart&&event.pointerType==='touch'){const dx=event.clientX-touchStart.x,dy=event.clientY-touchStart.y;if(Math.abs(dx)>60&&Math.abs(dy)<50)showItem(selected+(dx<0?1:-1));}touchStart=null;},{passive:true,signal});
 photo.addEventListener('pointercancel',()=>touchStart=null,{signal});
 const observer=new MutationObserver(updateText);observer.observe(root,{attributes:true,attributeFilter:['dir']});
 signal.addEventListener('abort',()=>{observer.disconnect();closeGallery();restore();},{once:true});
 render();
}
setupEmbrolabGallery();
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupEmbrolabGallery,{once:true});
document.addEventListener('shopify:section:load',setupEmbrolabGallery);
  } catch(e) { console.error(e); }
})();

})();
